import { logger } from '@/utils/logger';
import { env } from '@zopauk/nextjs-env';
import axios, { type AxiosInstance } from 'axios';
import { disableApiLogging, isDev, isCI } from '@/utils/helpers';
import { correlationInterceptor, loggerInterceptor } from '@zopauk/libs-axios';

let trustpilotClient: AxiosInstance;

/**
 * Set the Trustpilot api axios instance
 *
 * @returns AxiosInstance
 */
const initTrustpilotClient = () => {
  trustpilotClient = axios.create({
    params: {
      apikey: env('TRUSTPILOT_API_KEY'),
    },
    baseURL: env('TRUSTPILOT_API_URL'),
    withCredentials: false,
    timeout: 60000,
  });

  correlationInterceptor({ instance: trustpilotClient });
  loggerInterceptor({
    verbose: isCI ? false : isDev,
    identifier: 'TRUSTPILOT API',
    disabled: disableApiLogging,
    instance: trustpilotClient,
    logger,
  });

  return trustpilotClient;
};

export const getTrustpilotClient = () => trustpilotClient || initTrustpilotClient();
